import { queryOptions } from "@tanstack/react-query";
import {
  $getProjectExclusionCodes,
  $getProjectInvitations,
  $getProjectMembers,
} from "./functions";

export const projectMembersQueryOptions = (projectId: string) =>
  queryOptions({
    queryKey: ["projects", projectId, "members"],
    queryFn: ({ signal }) => $getProjectMembers({ signal, data: { projectId } }),
  });

export const projectInvitationsQueryOptions = (projectId: string) =>
  queryOptions({
    queryKey: ["projects", projectId, "invitations"],
    queryFn: ({ signal }) => $getProjectInvitations({ signal, data: { projectId } }),
  });

export const projectExclusionCodesQueryOptions = (projectId: string) =>
  queryOptions({
    queryKey: ["projects", projectId, "exclusion-codes"],
    queryFn: ({ signal }) => $getProjectExclusionCodes({ signal, data: { projectId } }),
  });
